import styled from 'styled-components'

import { media, spacing } from '../../../themes'
import { Snackbar } from '../Snackbar'
import { SNACKBAR_TRANSITION_DURATION } from '../Snackbar/styles'

interface StyledSnackbarProps {
  /**
   * Distance from the baseline in px
   */
  distance?: number
}

export const StyledSnackbar = styled(Snackbar)<StyledSnackbarProps>`
  pointer-events: auto;
  position: absolute;
  bottom: ${({ distance }) => (distance ? `${distance}px` : 0)};
  transition: all ${SNACKBAR_TRANSITION_DURATION / 1000}s ease-in-out;
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  pointer-events: none;
  width: calc(100% - ${spacing(4 * 2)});
  margin: ${spacing(14)} 0;
  top: 0;
  bottom: 0;

  ${media.tablet} {
    max-width: 768px;
  }
`
